module.exports = __webpack_public_path__ + "img/jpm_moon-icon@2x.c67946f6.png";